module.exports = __webpack_public_path__ + "media/images/imap_accounts/icon_ymobile-6171e160aa75851c922218397250cfc7.png";